import {ResultText} from './ResultText';

export function SummaryDragonRuns({runs,headingPrefix,renderValue=value=><ResultText value={value}/>}) {
 return <div className="summary-dragon-runs">{runs.map(run=><article className="summary-dragon-run" key={run.id}>
  <div className="summary-dragon-heading"><span>{headingPrefix || run.label}</span><strong>{headingPrefix&&`${run.label} · `}{run.type} · {run.atLeast?'≥':''}{run.count}期</strong></div>
  <div className="summary-dragon-sequence" aria-label={`${run.label}${run.type}完整序列，由旧到新`}>{run.sequence.map((value,index)=><span className="summary-dragon-token" key={index}>{renderValue(value,run)}</span>)}</div>
  <small>{run.start}–{run.end} · 由旧到新</small>
 </article>)}</div>;
}
